module.exports = __webpack_public_path__ + "img/venue-profile-placeholder.976f9a54.png";